module.exports = __webpack_public_path__ + "img/2-iconomis-tramites.8a7a9ee3.svg";